export type SelectOption = { label: string; value: string; disabled?: boolean };

/**
 * Builds `<Select>` options from a list of string values. Each option's value equals its label (the
 * stored value is the display string).
 *
 * There is deliberately no disabled placeholder row: pass the prompt as the `<Select>`'s
 * `placeholder` and give it `value={value || null}`, so an unset field reads as unset. An option
 * whose `value` is `''` styles the trigger as a *selection*, which renders the prompt in normal
 * text rather than placeholder grey.
 */
export function selectOptions(values: readonly string[]): SelectOption[] {
  return values.map((value) => ({ label: value, value }));
}
